import './home.scss'
import { time2str } from '@base/lang'
import { useEffect, useMemo } from 'react'
import Main from '@app/components/Main/Main'
import { useMaxWidth } from '@/hooks/useMaxWidth'
import Record from '@app/components/Record/Record'
import ActivityType from '@app/components/ActivityType/ActivityType'
import { emitter } from '@app/emitter'
import { Handler } from 'mitt'
import Share from '@/components/Share/Share'
import KowNav from '@app/components/KowNav/KowNav'
import CommonModal from '@/components/CommonModal/CommonModal'
import { useStore } from '@/store'
import { useLocal } from '@/i18n/LocalContext'
import Market from '@app/components/Market/Market'
import Lottery from '@app/components/Lottery/Lottery'
import SellList from '@app/components/SellList/SellList'
import Sell from '@app/components/Sell/Sell'
import ShareDialog from '@app/components/ShareDialog/ShareDialog'
import BookDialog from '@app/components/BookDialog/BookDialog'
import FinalSell from '@app/components/FinalSell/FinalSell'
import Receive from '@app/components/Receive/Receive'
import useReceive from '@app/hooks/useReceive'

export default function Home() {
  const { $t } = useLocal()
  const { state } = useStore()
  const startTime = state.startTime
  const endTime = state.endTime
  const playEndTime = state.playEndTime
  const zoneId = state.login.userInfo.zoneId
  const timezoneMap = state.timezoneMap
  const timeRuleText = useMemo(() => {
    let timezoneOffset = zoneId === 0 ? 0 : timezoneMap[zoneId]
    if (timezoneOffset === 0) {
      switch (window.queryObj.area) {
        case 'sea':
          timezoneOffset = timezoneMap[3]
          break
        case 'ea':
          timezoneOffset = timezoneMap[5]
          break
        default:
          timezoneOffset = timezoneMap[1]
          break
      }
    }
    const startTimeStr = time2str(
      (playEndTime + 1) * 1000 + timezoneOffset * 60 * 60 * 1000,
      'date-time',
      true
    )
    const endTimeStr = time2str(
      endTime * 1000 + timezoneOffset * 60 * 60 * 1000,
      'date-time',
      true
    )
    const playEndTimeStr = time2str(
      playEndTime * 1000 + timezoneOffset * 60 * 60 * 1000,
      'date-time',
      true
    )
    return $t('活动规则4')
      .replace('{start_time1}', startTimeStr)
      .replace('{start_time2}', startTimeStr)
      .replace('{end_time1}', playEndTimeStr)
      .replace('{end_time2}', endTimeStr)
  }, [startTime, endTime, playEndTime, timezoneMap, zoneId])
  const { width, safeAreaTop } = useMaxWidth()
  const widthStyle = useMemo(() => {
    const style = {
      width: `${width}px`,
      paddingTop: `${safeAreaTop}px`,
    }
    return style
  }, [width, safeAreaTop])
  const {
    receiveModalOpen,
    rewardViewList,
    rewardHideText,
    closeReceiveModal,
  } = useReceive()

  useEffect(() => {
    const mainSection = document.querySelector<HTMLElement>('.main')
    const marketSection = document.querySelector<HTMLElement>('.market')
    const lotterySection = document.querySelector<HTMLElement>('.lottery')

    const handler: Handler<MittEvents['selectActivity']> = (activity) => {
      ;[mainSection, marketSection, lotterySection].forEach((elem) => {
        if (elem) {
          elem.style.display = 'none'
        }
      })
      switch (activity) {
        case 'market':
          if (marketSection) {
            marketSection.style.display = 'flex'
          }
          if (mainSection) {
            mainSection.style.display = 'none'
          }
          if (lotterySection) {
            lotterySection.style.display = 'none'
          }
          break

        case 'lottery':
          if (lotterySection) {
            lotterySection.style.display = 'flex'
          }
          if (marketSection) {
            marketSection.style.display = 'none'
          }
          if (mainSection) {
            mainSection.style.display = 'none'
          }
          break

        default:
          if (mainSection) {
            mainSection.style.display = 'flex'
          }
          if (marketSection) {
            marketSection.style.display = 'none'
          }
          if (lotterySection) {
            lotterySection.style.display = 'none'
          }
          break
      }
    }
    emitter.on('selectActivity', handler)

    return () => {
      emitter.off('selectActivity', handler)
    }
  }, [])

  return (
    <>
      <KowNav />
      <div className="home" style={widthStyle}>
        <Main />
        <Market />
        <Lottery />
        <ActivityType />
      </div>
      <Record />
      <SellList />
      <Sell />
      <FinalSell />
      <Receive
        open={receiveModalOpen}
        hideText={rewardHideText}
        propList={rewardViewList}
        onClose={closeReceiveModal}
      />
      <ShareDialog />
      <BookDialog />
      <CommonModal
        open={state.modalData.ruleOpen}
        title={$t('活动规则')}
        type="rule"
        length="long"
      >
        {[
          <div key="1" className="rule-modal-body">
            <p
              className="common-modal-text"
              dangerouslySetInnerHTML={{ __html: $t('活动规则1') }}
            ></p>
            <p
              className="common-modal-text"
              dangerouslySetInnerHTML={{ __html: $t('活动规则2') }}
            ></p>
            <p
              className="common-modal-text"
              dangerouslySetInnerHTML={{ __html: $t('活动规则3') }}
            ></p>
            <p
              className="common-modal-text"
              dangerouslySetInnerHTML={{ __html: timeRuleText }}
            ></p>
          </div>,
        ]}
      </CommonModal>
      <Share />
    </>
  )
}
